/* eslint-disable */
import {
  $DomainEntity,
  $DomainEntityReflection,
  AttributeSelectionComponentState,
  EnhancedAliasReflection,
  Violation,
} from '@salsita-ai/platform-project-sdk/domain'

import {
  Admin,
  Countersink,
  CustomMaterial,
  DummyDoNotUse,
  FeatureSetting,
  Preset,
  PresetCategory,
  Recipe,
} from './admin-model/index.js'

export const constants = {} as const

interface PresetCategoryExpressions {
  readonly $isDraft: boolean
  readonly $admin: $Admin
  readonly $presets: readonly $Preset[]
}
const PresetCategoryExpressions = ['$isDraft', '$admin', '$presets']

interface CustomMaterialExpressions {
  readonly $rawMaterialOptions: AttributeSelectionComponentState['options']
  readonly $finishOptions: AttributeSelectionComponentState['options']
}
const CustomMaterialExpressions = ['$rawMaterialOptions', '$finishOptions']

interface FeatureSettingExpressions {
  readonly $plateTypeOptions: AttributeSelectionComponentState['options']
  readonly $featureTypeOptions: AttributeSelectionComponentState['options']
  readonly $anchorPointPositionOptions: AttributeSelectionComponentState['options']
  readonly $violations: ReadonlyArray<Violation<'noFeatureSettingDuplicatesAllowed'>>
}
const FeatureSettingExpressions = [
  '$plateTypeOptions',
  '$featureTypeOptions',
  '$anchorPointPositionOptions',
  '$violations',
]

interface AdminExpressions {
  readonly $customMaterials: readonly $CustomMaterial[]
  readonly $countersinks: readonly $Countersink[]
  readonly $featureSettings: readonly $FeatureSetting[]
  readonly $presets: readonly $Preset[]
  readonly $presetCategories: readonly $PresetCategory[]
  readonly $recipes: readonly $Recipe[]
}
const AdminExpressions = [
  '$customMaterials',
  '$countersinks',
  '$featureSettings',
  '$presets',
  '$presetCategories',
  '$recipes',
]

interface PresetExpressions {
  readonly $admin: $Admin
  readonly $category: $PresetCategory | null
  readonly $violations: ReadonlyArray<Violation<'nameCanNotBeEmpty'>>
}
const PresetExpressions = ['$admin', '$category', '$violations']

interface RecipeExpressions {
  readonly $admin: $Admin
}
const RecipeExpressions = ['$admin']

export type $Admin = $DomainEntity<Admin> & AdminExpressions
export const $Admin: $DomainEntityReflection<$Admin> = new $DomainEntityReflection('Admin', [...AdminExpressions])

export type $Preset = $DomainEntity<Preset> & PresetExpressions
export const $Preset: $DomainEntityReflection<$Preset> = new $DomainEntityReflection('Preset', [...PresetExpressions])

export type $PresetCategory = $DomainEntity<PresetCategory> & PresetCategoryExpressions
export const $PresetCategory: $DomainEntityReflection<$PresetCategory> = new $DomainEntityReflection('PresetCategory', [
  ...PresetCategoryExpressions,
])

export type $Recipe = $DomainEntity<Recipe> & RecipeExpressions
export const $Recipe: $DomainEntityReflection<$Recipe> = new $DomainEntityReflection('Recipe', [...RecipeExpressions])

export type $DummyDoNotUse = $DomainEntity<DummyDoNotUse>
export const $DummyDoNotUse: $DomainEntityReflection<$DummyDoNotUse> = new $DomainEntityReflection('DummyDoNotUse', [])

export type $CustomMaterial = $DomainEntity<CustomMaterial> & CustomMaterialExpressions
export const $CustomMaterial: $DomainEntityReflection<$CustomMaterial> = new $DomainEntityReflection('CustomMaterial', [
  ...CustomMaterialExpressions,
])

export type $Countersink = $DomainEntity<Countersink>
export const $Countersink: $DomainEntityReflection<$Countersink> = new $DomainEntityReflection('Countersink', [])

export type $FeatureSetting = $DomainEntity<FeatureSetting> & FeatureSettingExpressions
export const $FeatureSetting: $DomainEntityReflection<$FeatureSetting> = new $DomainEntityReflection('FeatureSetting', [
  ...FeatureSettingExpressions,
])

export type $AnyDomainEntity =
  | $Admin
  | $Preset
  | $PresetCategory
  | $Recipe
  | $DummyDoNotUse
  | $CustomMaterial
  | $Countersink
  | $FeatureSetting
export const $AnyDomainEntity: EnhancedAliasReflection<$AnyDomainEntity> = new EnhancedAliasReflection(
  '$AnyDomainEntity',
  [
    Admin.type,
    Preset.type,
    PresetCategory.type,
    Recipe.type,
    DummyDoNotUse.type,
    CustomMaterial.type,
    Countersink.type,
    FeatureSetting.type,
  ]
)

export type $RootEntity = $Admin
export const $RootEntity: EnhancedAliasReflection<$RootEntity> = new EnhancedAliasReflection('$RootEntity', [
  Admin.type,
])

export type $CommonAdminEntity = $Admin | $Preset | $PresetCategory | $Recipe
export const $CommonAdminEntity: EnhancedAliasReflection<$CommonAdminEntity> = new EnhancedAliasReflection(
  '$CommonAdminEntity',
  [Admin.type, Preset.type, PresetCategory.type, Recipe.type]
)

// eslint-disable-next-line @typescript-eslint/consistent-type-definitions
export type $Map = {
  Admin: $Admin
  Preset: $Preset
  PresetCategory: $PresetCategory
  Recipe: $Recipe
  DummyDoNotUse: $DummyDoNotUse
  CustomMaterial: $CustomMaterial
  Countersink: $Countersink
  FeatureSetting: $FeatureSetting
  AnyDomainEntity: $AnyDomainEntity
  RootEntity: $RootEntity
  CommonAdminEntity: $CommonAdminEntity
}

export const $entityReflections = {
  Admin: $Admin,
  Preset: $Preset,
  PresetCategory: $PresetCategory,
  Recipe: $Recipe,
  DummyDoNotUse: $DummyDoNotUse,
  CustomMaterial: $CustomMaterial,
  Countersink: $Countersink,
  FeatureSetting: $FeatureSetting,
}
